import { render, staticRenderFns } from "./complianceBus.vue?vue&type=template&id=874affac"
import script from "./complianceBus.vue?vue&type=script&lang=js"
export * from "./complianceBus.vue?vue&type=script&lang=js"
import style0 from "./complianceBus.vue?vue&type=style&index=0&id=874affac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports